module.exports = __webpack_public_path__ + "img/bg-login-page.c775fc31.svg";